import { render, staticRenderFns } from "./ChangeUserPasswordForm.vue?vue&type=template&id=0d5f1574&"
import script from "./ChangeUserPasswordForm.vue?vue&type=script&lang=js&"
export * from "./ChangeUserPasswordForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports